module.exports = __webpack_public_path__ + "static/media/numeros-unicred-prosperar.fb965f2b.png";